var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { format, isValid, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { translate } from '@lucidlink/uicore';
import { combineDateAndTime, getTimeOptions } from '#services';
export const useLinkExpirationTime = ({ date, time, }) => {
    _react_refresh_temp_1();
    const timeOptions = useMemo(() => getTimeOptions().options, []);
    const minDate = useMemo(() => format(startOfDay(new Date()), 'yyyy-LL-dd'), []);
    const calendarWordings = useMemo(() => ({
        calendarButtonAriaLabel: translate('Open calendar'),
        nextMonthButtonAriaLabel: translate('Next month'),
        prevMonthButtonAriaLabel: translate('Previous month'),
        visuallyHiddenDismissLabel: translate('Close calendar'),
    }), []);
    const isExpirationInPast = useMemo(() => {
        if (!date || !isValid(date) || !time) {
            return false;
        }
        return combineDateAndTime(date, time) <= new Date();
    }, [date, time]);
    return { calendarWordings, isExpirationInPast, minDate, timeOptions };
};
_react_refresh_temp_1(useLinkExpirationTime, "+2MAg+KOLvgSZmKdPvFsPGvVkyo=");
